/**
 * Localized notification rendering. Newer notifications store i18n KEYS
 * (ntf.*) in title/message with the values in `params`, so the bell shows
 * them in the user's language. Legacy rows hold plain prebuilt strings —
 * render those verbatim.
 */
export const notifText = (t, value, params) =>
  typeof value === 'string' && value.startsWith('ntf.') ? t(value, params || {}) : value;

export default notifText;
